export default {
  common: {
    requestError: '请求错误',
    serverError: '服务器开小差了~~~',
    confirm: '确认',
    cancel: '取消',
    delete: '删除',
    back: '返回',
    quit: '退出',
    add: '添加',
    copy: '复制',
    all: '全部',
    remove: '移除',
    project: '项目',
    folder: '文件夹',
    more: '更多操作',
    copySuccess: '复制成功',
    operateSuccess: '操作成功',
    addSuccess: '添加成功',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    cantPreview: '不支持预览',
    newFeature: '功能即将到来，敬请期待',
    noQuota: '您的账号已过期，请联系管理员！',
  },
  enum: {
    needReview: '需要审核',
    inProgress: '审核中',
    approved: '审核通过',
    disapproved: '审核未通过',
    noStatus: '无状态',
    reviewer: '审核员',
    admin: '管理员',
    editor: '协作者',
    collaborator: '协作者',
    owner: '拥有者',
    queue: '队列中',
    uploading: '上传中',
    paused: '暂停',
    completed: '上传完毕',
    failed: '失败',
    reading: '读取中',
  },
  login: {
    welcome: '欢迎回来！',
    description: '在这里尽情分享你创意的作品.',
    accountLogin: '账号密码登录',
    account: '用户名 / 手机号',
    password: '密码',
    start: '开始使用',
    noAccount: '还没有账号？ ',
    register: '注册账号',
    other: '其他第三方登录',
    wechat: '使用微信扫码',
    scan: '扫描成功',
    confirm: '请在手机上确认是否授权',
    back: '返回登录',
    captcha: '验证码',
    needModifyPassword: '密码复杂度过低，请修改密码',
  },
  register: {
    name: '用户名',
    account: '手机号',
    password: '密码',
    confirm: '注 册',
    had: '已经有账号了? ',
    login: '登录',
    passwordTip: '密码必须包含8到18个字符，并且至少包含数字、大小写字母和特殊字符中的三种',
    accountTip: '请输入2-18位登录名',
    phoneTip: '请输入正确的手机号',
    required: '请正确填写必要的信息',
    success: '注册成功，请登录'
  },
  main: {
    home: '主页',
    search: '搜索',
    add: '添加项目',
    jump: '跳转到文件夹或文件',
    progress: '上传进度',
    contact: '联系我们',
    locale: '切换语言',
    logout: '登出',
    confirmLogout: '有文件正在上传，登出将取消上传，确认登出?',
    project: '我的项目',
    manage: '成员管理',
    cancelTop: '取消置顶',
    top: '置顶项目',
    setting: '项目设置',
    allowDownload: '允许下载',
    allowShare: '允许分享',
    allowCollect: '允许收集',
    delete: '删除项目',
    quit: '退出项目',
    empty: '团队没有项目，点击新建项目按钮创建新的项目',
    confirmQuit: '确认退出项目{0}',
    confirmDelete:
      '确认删除项目{0}? 所有项目管理的文件将直接被删除, 且永久无法恢复！！<br /> <br /> 请输入”删除“以确认删除项目',
      confirmDeleteTips: '请输入"删除"以确认删除项目',
  },
  collect: {
    confirmDelete: '确认要删除”{0}“吗',
    copyLinkSuccess: '复制链接成功',
    copyPasswordSuccess: '复制密码成功',
    copyUsernameSuccess: '复制用户名成功',
    wechatScan: '使用微信扫码',
    copyPasswordTips: '点击复制密码',
    copyUsernameTips: '点击复制用户名',
    copyLink: '复制链接',
    shareLink: '分享链接',
    allowComment: '允许评论',
    allowUpload: '允许上载',
    shareFTP: 'FTP共享',
    allowDownload: '允许下载',
    forever: '永久有效',
    linkForever: '链接永久有效',
    expireTo: '有效期至{0}',
    day: '{0}天',
    accessPassword: '访问密码',
    username: '用户名',
    expire: '访问期限',
    expireTips: '选择访问期限',
    description: '添加描述（例如文件格式的要求，选填）',
    tips: '此链接不再可访问。如果您仍然需要访问，请联系帐户所有者',
    back: '返回Frame.Lux',
    chooseFiles: '选择文件',
    chooseFolders: '选择文件夹',
    upload: '上传',
    noSpace: '空间不足, 请联系管理员升级/续费',
    password: '请输入密码',
    passwordTips: '请输入正确的密码',
  },
  upload: {
    complete: '上传完成',
    waiting: '等待中',
    abandon: '放弃',
    continue: '继续',
    confirm: '请确认',
    confirmMsg: '列表中有未上传的文件，你要放弃上传吗？',
    empty: '没有正在上传的文件',
    uploaded: '上传成功 {0} 项',
    canelAll: '全部取消',
    uploading: '正在上传 {complete} / {total}',
    pause: '暂停',
    recover: '恢复',
    cancel: '取消',
    cancelAll: '全部取消',
    open: '打开所在文件夹',
  },
  search: {
    filters: '过滤条件',
    filterCount: '{0}个条件',
    addFilter: '添加过滤条件',
    tips: '搜索素材和文件夹',
    empty: '未找到相关结果',
  },
  file: {
    label: '标签',
    project: '项目',
    audit: '审核状态',
    accessStatus: '访问状态',
    link: '链接',
    expire: '有效期',
    createTime: '创建时间',
    deleteTime: '删除时间',
    views: '浏览次数',
    deletor: '删除者',
    fileName: '文件名',
    resolution: '分辨率',
    framerate: '帧率',
    codec: '视频编码',
    bitrate: '比特率',
    audioCount: '音轨数',
    audioSampleRate: '音频采样率',
    scanType: '扫描模式',
    pregressive: '隔行',
    interlaced: '逐行',
    duration: '时长',
    title: '标题',
    uploadTime: '上传时间',
    uploader: '上传者',
    size: '大小',
    status: '状态',
    type: '类型',
    operation: '操作',
    queued: '排队中',
    paused: '暂停中',
    importFailed: '导入失败',
  },
  share: {
    download: '下载原件',
    tips: '此链接不再可访问。如果您仍然需要访问，请联系帐户所有者',
    back: '返回Frame.Lux',
    noFile: '暂无文件！',
    root: '{0}分享的文件',
    noDownload: '没有文件需要下载',
    downloading: '{0}个文件正在下载',
    password: '请输入密码',
    passwordTips: '请输入正确的密码',
  },
  player: {
    play: '播放 [K]',
    pause: '暂停 [K]',
    loop: '循环',
    unmute: '取消静音 [M]',
    mute: '静音 [M]',
    timecode: '时码',
    standard: '标准',
    frame: '帧',
    code: '时间码',
    collapseCut: '收起裁剪',
    cancelComment: '取消批注',
    cancelCommentSelect: '取消批注选中',
    playbackRate: '倍速',
    standardSpeed: '正常',
    linkTimeline: '链接时间线',
    fullscreen: '全屏 [F]',
    exitFullscreen: '退出全屏 [Esc]',
    playlist: '播放列表 [Tab]',
  },
  review: {
    fileDeleted: '该文件已被删除',
    forbidden: '无操作权限',
    cantPreview: '文件暂无法预览，请稍后再试',
    download: '下载',
    saveAs: '转存',
    print: '打印批注',
    commentTitle: '批注',
    fileTitle: '文件信息',
    addTag: '新增/搜索标签',
    allTag: '全部标签',
    addTagTips: '请添加标签',
    noTagTips: '暂无标签',
    allUser: '所有人',
    timecode: '按时间码',
    time: '按批注时间',
    modifySuccess: '修改成功',
    deleteSuccess: '删除成功',
    sendSuccess: '发送成功',
    deleteComment: '删除批注',
    confirmDelete: '确认删除批注[{0}]',
    undo: '撤销上一步',
    redo: '恢复撤销',
    clear: '清除画布并退出',
    commentTips: '请输入你的审评意见...',
    addTimecode: '添加时间戳',
    at: '提到',
    attach: '附件',
    send: '发送',
  },
  project: {
    mode916: '9:16',
    modeList: '列表',
    modeThumb: '缩略图',
    moveTo: '移动到',
    copyTo: '复制到',
    defaultFolder: '新建文件夹',
    defaultProject: '新建项目',
    defaultNote: '新建创意文稿',
    assignRole: '分配角色',
    modifyTips: '确认修改用户[{name}]为[{role}]角色',
    removeMember: '移除用户',
    removeTips: '确认移除用户[{0}]',
    memberCount: '{0} 位成员在这个项目中',
    invite: '邀请',
    searchUserTips: '输入名字搜索',
    noMatchTips: '没有找到对应的用户',
    space: '占用空间<span class="emphasize">{size}</span>',
    count:
      '包含<span class="emphasize">{assetCount}</span>个文件，<span class="emphasize">{folderCount}</span>个文件夹',
    sortByTitle: '按标题排序',
    sortByTime: '按时间排序',
    sortByType: '按类型排序',
    sortByStatus: '按状态排序',
    new: '新建',
    uploadFiles: '上传文件',
    uploadFolders: '上传文件夹',
    newFolder: '新建文件夹',
    newNote: '新建创意文稿',
    newProject: '新建项目',
    collect: '收集文件',
    ftp: '创建FTP链接',
    refresh: '刷新',
    file: '项目文件',
    trashcan: '回收站',
    shareLink: '审片分享',
    collectLink: '收集链接',
    ftpLink: 'FTP链接',
    folderTitle: '文件夹',
    fileTitle: '文件',
    empty: '还没有文件！',
    trashcanEmpty: '回收站为空, 你可以在这里将删除的文件还原',
    shareEmpty: '暂无分享链接, 创建分享链接之后可以在这里进行查看',
    collectEmpty: '暂无收集链接, 创建收集链接之后可以在这里进行查看',
    ftpEmpty: '暂无FTP链接, 创建FTP链接之后可以在这里进行查看',
    shareSetting: '分享设置',
    deleteShare: '删除分享',
    ftpSetting: 'FTP设置',
    deleteFtp: '删除FTP',
    passwordCopySuccess: '密码复制成功',
    collectSetting: '收集设置',
    deleteCollect: '删除收集',
  },
  notification: {
    notificationSetting: '通知设置',
    allRead: '全部已读',
    deleteRead: '删除已读',
    emptyNotification: '暂无消息',
    notification: '通知',
    emptyMsg: '暂无消息',
    msg: '消息',
    atMsg: "{'@'}消息",
    project: '项目',
    at: '<span class="bold">{who}</span>在<span class="bold ">{name}</span>中{\'@\'}了你',
  },
  menu: {
    clear: '清空回收站',
    restoreTo: '放回原处',
    delete: '删除',
    download: '下载',
    copyTips: '您的空间已满，请联系管理员扩展空间大小或清理空间再进行复制',
    copyTo: '复制到',
    moveTo: '移动到',
    rename: '重命名',
    share: '分享',
    pictureImagine: '图生图',
    speechToText: '语音识别',
    publish: '发布',
    deleteFile: '删除文件',
    deleteFileCount: '删除{0}个文件',
    confirmDeleteFile: '确认删除文件“{0}”？删除后，文件将被移至回收站。',
    confirmDeleteFileCount: '确认删除这{0}个文件？删除后，文件将被移至回收站。',
    emptyDownloadTips: '没有文件需要下载',
    downloadCount: '{0}个文件正在下载',
    renameSuccess: '重命名成功',
    renameFile: '重命名文件',
    renameFolder: '重命名文件夹',
    noSpaceTips: '您的空间已满，请联系管理员扩展空间大小或清理空间再进行上传',
    createShare: '创建分享',
    createCollect: '创建收集',
    createFtp: '创建FTP链接',
    projectMembers: '项目成员',
    purgeFile: '永久删除文件',
    purgeFileCount: '永久删除{0}个文件',
    confirmPurgeFile: '确认永久删除{0}',
    confirmPurgeFileCount: '确认永久删除{0}个文件?',
    purge: '永久删除',
    restore: '恢复',
    restoreFile: '恢复文件',
    restoreFileCount: '恢复{0}个文件',
    confirmRestoreFile: '确认恢复{0}',
    confirmRestoreFileCount: '确认恢复{0}个文件?',
  },
  other: {
    teamTips: '有文件正在上传, 切换团队将取消上传, 是否确认',
    publish: '发布中心',
    personal: '个人中心',
    tools: 'AI 工具',
    logout: '退出登录',
    space: '空间用量',
    equal: '等于',
    contactTips: '有任何建议或问题，请扫描二维码联系我们',
  },
  editor: {
    loading: '生成中...',
    askAi: 'AI',
    script1: '生成宣传文案',
    script2: '生成直播话术',
    script3: '内容仿写',
  },
  imagination: {
    imagination: '图生图',
    generate: '生成',
    generateTips: '请输入关键字',
    save: '保存',
    suggest: '推荐提示',
    download: '下载',
    variation: '偏好 {0}',
    upscale: '确认 {0}',
    reroll: '重新生成'
  },
  password: {
    title: '修改密码',
    oldPassword: '旧密码',
    newPassword: '新密码',
    modifySuccess: '密码修改成功',
    requiredTips: '请正确填写必要的信息',
    needInitPassword: '为了您账户的安全，请先修改初始密码',
    needModifyPassword: '密码长时间未修改，为了您账号为了您账户的安全，请先修改密码', // 太长时间没有修改密码
    passwordTips: '密码必须包含8到18个字符，并且至少包含数字、大小写字母和特殊字符中的三种',
    passwordDuplicate: '您不能重复使用最近三次的旧密码，请重新设置新密码',
    passwordIncorrect: '旧密码错误',
  }
}
